import { House, Compass, Luggage, CircleUserRound } from 'lucide-react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MobileBottomBar = () => {
  const location = useLocation();

  const isSearchPage = location.pathname === "/search";

  const navItems = [
    { to: '/', label: 'Home', icon: House },
    { to: '/explore', label: 'Explore', icon: Compass },
    { to: '/account/bookings', label: 'Bookings', icon: Luggage },
    { to: '/account', label: 'Account', icon: CircleUserRound },
  ];

  return (
    <nav
      className={`d-md-none fixed-bottom bg-white border-top ${isSearchPage ? 'd-none' : 'd-block'}`}
      style={{ zIndex: 1030 }}
    >
      <div className="d-flex justify-content-around align-items-center py-2">
        {navItems.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <Link
              to={item.to}
              key={index}
              className={`text-center d-flex flex-col items-center small text-decoration-none ${location.pathname === item.to ? 'text-primary' : 'text-muted'
                }`}
            >
              <IconComponent className='fs-5 d-block mb-1' size={22} strokeWidth={1.5} />
              <span>{item.label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  );
};

export default MobileBottomBar;
